import React from "react";
import withStyles from "components/with-styles";
import CopyrightContent from "components/copyright";
import styles from "./styles/page-footer-copyright.css.js";

const Copyright = ({ classes }) => (
  <div className={classes.page_footer_copyright}>
    <CopyrightContent />
  </div>
);

export default withStyles(styles)(Copyright);
